export function isActor(item) {
    try {
        return typeof item.send === 'function';
    } catch (e) {
        return false;
    }
}
//# sourceMappingURL=Actor.js.map


//////////////////
// WEBPACK FOOTER
// ./~/xstate/es/Actor.js
// module id = 1122
// module chunks = 0